// 课程详情页面配置
export default {
  teacher: 'Tutor',
  discountPrice: 'Discounted price',
  taxiInclude: 'inc VAT',
  taxiExcluded: 'VAT excluded',
  btnStatus: {
    unavailable: 'Unavailable',
    courseEnded: 'Course Ended',
    forSale: 'For Sale',
    full: 'Full',
    enrolNow: 'Enrol Now',
    enrol: 'Enrol',
    autoPayInProcess: 'Auto pay in process',
  },
  signUpCheckInfoDialog: {
    case1: {
      title: 'Please take the Level Test',
      content: 'Your child must pass the Level Test before signing up to this course. {0} attempt{1} remaining',
      mainBtnText: 'Start test',
    },
    case604: {
      title: 'Unable to sign up',
      content: 'Sorry, this course is only available for new users, and each user can only sign up once. Come and browse more courses!',
      mainBtnText: 'View courses',
      subBtnText: 'Cancel',
    },
  },
  evaluationStatusTxt: {
    case1: 'Take the Level Test to find out which course is best suited for your child',
    case2: 'Your child must take the Level Test before signing up for this course',
    case3: 'Your child passed the Level Test. You can sign up now',
    case4: 'Your child\'s Level Test results suggest that this course is too difficult',
  },
};
